import { Property, PropertyType } from '../../../../base/types';

import { IProperty } from '../../../../base/models';

export const TouUmsLinkProperties: IProperty[] = [
   
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Target, name: 'Target', type: PropertyType.String },
    { id: Property.Title, name: 'Title', type: PropertyType.String },
   
]
